// src/redux/auth/thunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post("/auth/signinAdmin", credentials);
      // console.log("Full Response:", response.data);

      const data = response.data.data || response.data;
      // console.log("Extracted Data:", data);
      const authUser = {
        status: "success",
        data: {
          email: data.user?.email || data.email,
          username: data.user?.fullName || data.username,
          token: data.token?.startsWith("Bearer")
            ? data.token
            : `Bearer ${data.token}`,
          role: data.user?.role || data.role,
        },
      };

      sessionStorage.setItem("authUser", JSON.stringify(authUser));

      return authUser;
    } catch (error) {
      console.error("Login error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
